import React from 'react'
import { connect } from 'react-redux'
import GxtPills from '../gxt-pills'
import GxtChart from '../gxt-charts'
// import moment from 'moment';

export const Index = ({ patientId, token, gxtLoading }) => {
    // const dispatch = useDispatch()

    return (
        <div>
            <div className="d-flex w-100">
                <div className="small-chart">
                    {gxtLoading ? (
                        <img style={{ width: '35px' }} src="/loader.gif" alt="loader" />
                    ) : (
                        <GxtChart />
                    )}
                </div>
                <div className="ms-3 w-100">
                    <GxtPills name="dashboard-pills" time="" />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    patientId: state.patient.patientData.patientId,
    token: state.loginData.loginResponse.accessToken,
    gxtLoading: state.gxt.loading,
})

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
